import { appConfig } from '../config';

export enum ServicesEnum {
  adesivo = 'Adesivo',
  aluguel = 'Aluguel de máquinas',
  Corte = 'Corte a laser',
  Gravação = 'Gravação a laser',
  Decalque = 'Decalque',
  Etiqueta = 'Etiqueta resinada',
  Envelopamento = 'Envelopamento',
  Hot = 'Hot stamping',
  Silkscreen = 'Silkscreen',
  Sublimação = 'Sublimação',
  Tampo = 'Tampo',
  Transfer = 'Transfer',
}

export enum AppRoutePaths {
  ACTIVITIES = '/activities',
  ACTIVITIES_EXPORT = '/activities/export',
  ART_ACTIVITY = '/art-activities/:id',
  ACTIVITY_LAYOUTS = '/activity-layouts',
  LOGIN = '/',
  BUDGET = '/budget',
  BUDGET_LIST = '/budgets',
  CONFIRM_BUDGET = '/confirm-budget',
  HOME = '/home',
  CREATE_ORDER = '/create-order',
  NOT_FOUND = '*',
  ORDER_DETAILS = '/order/:id',
  ORDERS = '/orders',
  ORDERS_LATE = '/orders/late',
  ORDERS_FIRST_CONTACT = '/orders/first-contact',
  ORDER_HISTORIC = '/order-historic',
  ORDER_PRODUCTION = '/order-production/:id',
  ORDER_SCREEN = '/order-screen/:id',
  ORDER_HANDLING = '/order-handling/:id',
  ORDER_PACKING = '/order-packing/:id',
  ORDERS_FIRST_PIECE = '/orders/first-piece',
  EDIT_ORDER = '/order/edit/:id',
  USERS = '/users',
  USERS_CREATE = '/users-create',
  USERS_EDIT = '/users/edit/:id',
  COMPANY = '/companies',
  COMPANY_CREATE = '/companies-create',
  COMPANY_EDIT = '/companies/edit/:id',
  RESET_PASSWORD = '/reset-password',
  TEAMS = '/teams',
  TEAMS_CREATE = '/teams-create',
  TEAMS_EDIT = '/teams/edit/:id',
  ORDER_DISPATCH = '/order-dispatch/:hash',
  ORDER_MATERIALS = '/order-materials',
  ORDER_MATERIALS_PENDING = '/order-materials/pending',
  ORDER_MATERIALS_CREATE = '/order-materials-create',
  ORDER_MATERIALS_EDIT = '/order-materials/edit/:id',
  ORDER_MATERIALS_DETAILS = '/order-materials/details/:id',
  ORDER_MATERIALS_ENTRIES = '/order-materials/entries',
  FINANCIAL_INVOICE = '/finances/invoices',
  FINANCIAL_PAYMENT = '/finances/payments',
  REPORTS_PRODUCTION = '/reports-production',
  REPORTS_HANDLING = '/reports-handling',
  REPORTS_PAYMENTS = '/reports-payments',
  REPORTS_ART = '/reports-art',
  ORDER_ACTIVITIES_SUMMARY = '/reports-order-activities-summary',
  PURCHASES = '/purchases',
  PURCHASES_CREATE = '/purchases-create',
  PURCHASES_EDIT = '/purchases/edit/:id',
  BILLS = '/bills',
  BILLS_CREATE = '/bills-create',
  BILLS_EDIT = '/bills/edit/:id',
  POSTAL_LIST = '/postals',
  POSTAL_CREATE = '/postals-create',
  POSTAL_EDIT = '/postals-edit/:id',
  RECEIPT_LIST = '/receipts',
  ORDER_PCP = '/order-pcp',
  SAC_LIST = '/sac',
  SERVICE_ITEM_LIST = '/service-items',
  OPTION_LIST = '/options',
  OPTION_CREATE = '/options/create',
  OPTION_EDIT = '/options/edit/:id',
  ORDER_DEFECT = '/orders/defect/:id',
  ORDER_FILE_RECEIPTS_APPROVAL = '/file-receipts-approval',
  ORDER_EVENT_CREATE = '/order-events/create',
  ORDER_EVENT_EDIT = '/order-events/:id',
  ORDER_EVENT_LIST = '/order-events',
  PAYMENT_SLIP_LIST = '/payment-slip',
  SEGMENTATION_TAG_LIST = '/segmentation-tags',
  SAC_RATE = '/sac/rate/:hash',
  CLIENT_ORDER_CANCEL = '/order-cancel/:id',
  ORDER_APPROVALS = '/orders/approvals',
  STOCK_LIST = '/stock',
  STOCK_REQUEST_LIST = '/stock-request',
  STOCK_CREATE = '/stock/create',
  STOCK_REQUEST_CREATE = '/stock-request-create',
  STOCK_EDIT = '/stock/edit/:id',
  ORDER_WITHDRAWAL = '/order-withdrawal',
  ORDER_WITHDRAWAL_DETAILS = '/order-withdrawal/details/:ids',
  ORDER_WITHDRAWAL_CREATE = '/order-withdrawal/create',
  ORDER_TRACK = '/order/:id/track',
  CLIENT_ORDER_APPROVAL_DEADLINE = '/confirm-deadline/:id',
  ORDER_UNPACKING = '/order-unpacking/:id',
  ORDER_RATE = '/order/:id/rate',
  FINANCIAL_CHECK = '/order/financial-check',
  PRICE_CONFERENCE = '/order/price-conference',
  REPORTS_EVENTS = '/reports-events',
  REPORT_ORDERS = '/reports-orders',
  FINANCIAL_NF_CONTROL = '/finances/nf/control',
  ORDERS_XBZ = '/orders/xbz',
  PRODUCTS_XBZ = '/products/xbz',
  PRODUCT_XBZ_DETAILS = '/products/xbz/:code',
  COMPANY_XBZ = '/companies/xbz',
  CREATE_ORDERS_XBZ = '/orders/create/xbz/:ids',
  ORDER_MATERIAL_MOBILE = '/order-materials/mobile/:id',
  CREATE_ORDERS_KIT = '/orders/create/kit',
  CHAT = '/chat',
  CHAT_MONITOR = '/chat-monitor',
  ORDER_TRANSFER = '/order/transfer',
  TERM_DOCUMENTS = '/term-documents',
}

export const LocalStorageKeys = {
  AUTH_TOKEN: `${appConfig.devName}:auth:user`,
  NOTIFICATIONS: `${appConfig.devName}:notifications`,
  PRODUCT_ENTRY_PAYLOAD: 'product_entry_payload',
};

export enum DefectType {
  PRODUCT_DEFECT = 'product_defect',
  INCORRECT_QUANTITY = 'incorrect_quantity',
}

export enum ApprovalType {
  SEND = 'send',
  NOT_SEND = 'not_send',
}

export enum PermissionAlias {
  // Materiais (existentes)
  VIEW_MATERIAL_VOLUME_TRANSFER = 'view_material_volume_transfer',
  HANDLE_MATERIAL_VOLUME_TRANSFER = 'handle_material_transfer',
  VIEW_ORDER_MATERIAL = 'view_order_material',
  CREATE_ORDER_MATERIAL = 'create_order_material',
  EDIT_ORDER_MATERIAL = 'edit_order_material',
  DELETE_ORDER_MATERIAL = 'delete_order_material',
  VIEW_PENDING_ORDER_MATERIAL = 'view_pending_order_material',

  // Pedidos
  VIEW_ORDERS = 'view_orders',
  CREATE_ORDERS = 'create_orders',
  EDIT_ORDERS = 'edit_orders',

  // Produção
  VIEW_ORDER_PRODUCTIONS = 'view_order_productions',
  MANAGE_ORDER_PRODUCTIONS = 'manage_order_productions',

  // Serigrafia
  VIEW_ORDER_SCREENS = 'view_order_screens',
  MANAGE_ORDER_SCREENS = 'manage_order_screens',

  // Arte Final
  VIEW_ACTIVITIES = 'view_activities',
  MANAGE_ACTIVITIES = 'manage_activities',

  // Embalagem
  VIEW_ORDER_PACKINGS = 'view_order_packings',
  MANAGE_ORDER_PACKINGS = 'manage_order_packings',

  // Financeiro
  VIEW_FINANCIAL = 'view_financial',
  MANAGE_FINANCIAL = 'manage_financial',
  VIEW_RECEIPTS = 'view_receipts',
  MANAGE_RECEIPTS = 'manage_receipts',
  VIEW_BILLS = 'view_bills',
  MANAGE_BILLS = 'manage_bills',

  // Empresas
  VIEW_COMPANIES = 'view_companies',
  MANAGE_COMPANIES = 'manage_companies',
  VIEW_COMPANY_BALANCES = 'view_company_balances',
  MANAGE_COMPANY_BALANCES = 'manage_company_balances',

  // Estoque
  VIEW_STOCK = 'view_stock',
  MANAGE_STOCK = 'manage_stock',
  MANAGE_STOCK_REQUESTS = 'manage_stock_requests',

  // Expedição / Retiradas
  VIEW_WITHDRAWAL = 'view_withdrawal',
  MANAGE_WITHDRAWAL = 'manage_withdrawal',
  VIEW_ORDERS_TRANSFER = 'view_orders_transfer',
  MANAGE_ORDERS_TRANSFER = 'manage_orders_transfer',

  // Tickets / SAC
  VIEW_TICKETS = 'view_tickets',
  MANAGE_TICKETS = 'manage_tickets',

  // Postagem
  VIEW_POSTALS = 'view_postals',
  MANAGE_POSTALS = 'manage_postals',

  // Remessas
  VIEW_PAYMENT_SLIP_GROUPS = 'view_payment_slip_groups',
  MANAGE_PAYMENT_SLIP_GROUPS = 'manage_payment_slip_groups',

  // Relatórios / Metas
  VIEW_EXPORTABLES = 'view_exportables',
  VIEW_REPORT_ORDERS = 'view_report_orders',
  VIEW_REPORT_ACTIVITIES = 'view_report_activities',
  VIEW_REPORT_ART = 'view_report_art',
  VIEW_REPORT_PRODUCTION = 'view_report_production',
  VIEW_REPORT_HANDLING = 'view_report_handling',
  VIEW_REPORT_PAYMENTS = 'view_report_payments',
  VIEW_REPORT_EVENTS = 'view_report_events',
  VIEW_SALE_GOALS = 'view_sale_goals',
  MANAGE_SALE_GOALS = 'manage_sale_goals',

  // Orçamentos / Chat
  VIEW_BUDGET = 'view_budget',
  MANAGE_BUDGET = 'manage_budget',
  ACCESS_CHAT_ADMIN = 'access_chat_admin',

  // Movimentações (order-handlings)
  VIEW_ORDER_HANDLINGS = 'view_order_handlings',
  MANAGE_ORDER_HANDLINGS = 'manage_order_handlings',

  // Layouts de pedido (order-layouts)
  MANAGE_ORDER_LAYOUTS = 'manage_order_layouts',

  // Layouts de atividade / arte (activity-layouts)
  MANAGE_ACTIVITY_LAYOUTS = 'manage_activity_layouts',

  // Aprovações de produção (order-production-approvals)
  MANAGE_ORDER_PRODUCTION_APPROVALS = 'manage_order_production_approvals',

  // Solicitações de mudança (order-change-requests)
  VIEW_ORDER_CHANGE_REQUESTS = 'view_order_change_requests',
  MANAGE_ORDER_CHANGE_REQUESTS = 'manage_order_change_requests',

  // Eventos de pedido (order-events)
  VIEW_ORDER_EVENTS = 'view_order_events',
  MANAGE_ORDER_EVENTS = 'manage_order_events',

  // Documentos de empresa (company-documents)
  VIEW_COMPANY_DOCUMENTS = 'view_company_documents',
  MANAGE_COMPANY_DOCUMENTS = 'manage_company_documents',

  // Compras (purchases)
  VIEW_PURCHASES = 'view_purchases',
  MANAGE_PURCHASES = 'manage_purchases',

  // Entrada de produtos (product-entry)
  MANAGE_PRODUCT_ENTRY = 'manage_product_entry',

  // Etiquetas (tag)
  MANAGE_TAGS = 'manage_tags',

  // Tags de segmentação (segmentation-tags)
  MANAGE_SEGMENTATION_TAGS = 'manage_segmentation_tags',
}
